<template>
  <b-container class="my-4">
    <b-row class="mb-3">
      <b-col class="mt-3" cols="12" lg="7" md="12" sm="12" xl="7">
        <b-card class="cardStyle" style="background: #FFFFFF;">
          <div v-if="!helpTopicLoading">
            <b-breadcrumb class="m-0 px-0" style="background: #FFFFFF;">
              <b-breadcrumb-item @click="$router.push({ name: 'support' })">
                <b-icon aria-hidden="true" icon="chevron-left" scale="1" shift-v="1"></b-icon>
                My Pfizer Studies Support
              </b-breadcrumb-item>
              <b-breadcrumb-item active> {{ helpTopic['categoryTitle'] }}</b-breadcrumb-item>
            </b-breadcrumb>
            <div>
              <h4 class="my-4">{{ helpTopic.title }}</h4>
              <span class="mt-3" style="word-wrap: break-word;" v-html="helpTopic.body"></span>
            </div>
          </div>
          <div v-if="helpTopicLoading" class="text-center text-primary my-5">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </b-card>
      </b-col>
      <b-col class="mb-3" cols="12" lg="5" md="12" sm="12" xl="5">
        <b-row>
          <b-col class="mt-3" cols="12" lg="12" md="7" sm="12" xl="12">
            <b-card class="cardStyle" no-body>
              <b-card-body v-if="!categoryLoading">
                <b-card-title>{{ helpTopic['categoryTitle'] }}</b-card-title>
                <div v-if="categoryTopics.length > 0">
                  <hr class="solid" />
                  <div>
                    <div v-for="topic in categoryTopics" :key="topic['id']" class="mb-2">
                      <a
                        :class="helpTopic.id === topic.id ? 'disabled-link ' : ''"
                        class="py-0 topic-title"
                        @click="redirect(topic.category, topic.id)"
                        >{{ topic.title }}
                      </a>
                    </div>
                  </div>
                  <hr class="solid" />
                </div>
              </b-card-body>
              <div v-if="categoryLoading" class="text-center text-primary my-5">
                <b-spinner class="align-middle primary"></b-spinner>
                <strong>Loading ...</strong>
              </div>
            </b-card>
          </b-col>
          <b-col class="mt-3" cols="12" lg="12" md="7" sm="12" xl="12">
            <contact-support :helpTopicTitle="helpTopic.title"></contact-support>
          </b-col>
          <b-col
            v-if="attachments.length > 0"
            class="mt-3"
            cols="12"
            lg="12"
            md="5"
            sm="12"
            xl="12"
          >
            <b-card class="cardStyle attachmentsCard">
              <div>
                <b-icon icon="paperclip"></b-icon>
                Attachments
              </div>
              <hr class="solid" />
              <ul>
                <li v-for="attachment in attachments" :key="attachment.id" class="mb-1">
                  <a :href="getLink(attachment)">{{ getAttachmentName(attachment) }} </a>
                </li>
              </ul>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import ContactSupport from './ContactSupport';

  export default {
    components: {
      ContactSupport,
    },
    data() {
      return {
        helpTopic: {},
        helpTopicLoading: false,
        categoryLoading: false,
        categoryTopics: [],
        attachments: [],
      };
    },
    created() {
      this.getHelpTopic();
      this.getCategoryTopics();
    },
    watch: {
      $route() {
        this.getHelpTopic();
        this.getCategoryTopics();
      },
    },
    methods: {
      redirect(category, id) {
        this.$router.push({
          name: 'help-topic',
          params: {
            category: category,
            Id: id,
          },
        });
      },
      async getHelpTopic() {
        this.helpTopicLoading = true;
        try {
          let response = await axios.get(`/api/get-help-topic/${this.$route.params['Id']}`);
          this.helpTopic = response.data.data;
          this.attachments = this.helpTopic['attachments'] || [];
        } catch (error) {
          console.log(error);
        }
        this.helpTopicLoading = false;
      },
      async getCategoryTopics() {
        try {
          this.categoryLoading = true;
          let response = await axios.get(`/api/get-help-topics`, {
            params: { category: this.$route.params['category'] },
          });
          if (response.status !== 204) {
            this.categoryTopics = response.data['items'].filter(el => {
              return el['showInSupportPage'];
            });
            this.categoryTopics.sort(
              (firstItem, secondItem) => secondItem.priority - firstItem.priority,
            );
          }
        } catch (error) {
          console.error(error);
          alert(`Server is not responding, please try again later`);
        }
        this.categoryLoading = false;
      },
      getLink(attachment) {
        return (
          '/api/get-salesforce-attachment?id=' +
          attachment['versionID'] +
          '&name=' +
          this.getAttachmentName(attachment) +
          '&size=' +
          attachment['contentSize']
        );
      },
      getAttachmentName(attachment) {
        return attachment['title'] + '.' + attachment['extension'];
      },
    },
  };
</script>

<style scoped>
  .support-sideCard-title {
    height: 100%;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
  }

  .attachmentsCard {
    height: 100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
  }

  .topic-title {
    min-height: 50px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    text-decoration: underline;
    color: #0064c1;
    cursor: pointer;
  }

  .disabled-link {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.4;
  }
</style>
